// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// Import 3rd part libraries
import Swiper from 'swiper/bundle';
import Mmenu from 'mmenu-js';
import Lightbox from 'lightbox2';
import JSShare from 'js-share';
import ClipboardJS from 'clipboard';
import { Tooltip } from 'bootstrap';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
});

window.jQuery = jQuery;

window.Swiper = Swiper;
window.Mmenu = Mmenu;

window.Lightbox = Lightbox;
window.JSShare = JSShare;
window.ClipboardJS = ClipboardJS;
window.Tooltip = Tooltip;

// Load Events
jQuery(function(){routes.loadEvents();});
